import React from 'react'

const TextIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    style={props.styles}
    fill={props.fill}
    viewBox="0 0 24 24"
  >
    <path d="M22,4C22,2.89 21.1,2 20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H18L22,22V4Z" />
  </svg>
  )

export default TextIcon



// WEBPACK FOOTER //
// ./src/components/assets/TextIcon.js